"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _programNameCardUpdater["default"];
  }
});
var _programNameCardUpdater = _interopRequireDefault(require("./programNameCardUpdater"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }